export const EVENT_NAME_MAX_LENGTH = 25;
export const RESERVATION_TYPE_ABBREVIATION = 'Res.';

export const formatEventTypeDropdownLabel = (
	eventTypeLabel: string,
	isReservation = false
): string => {
	const label = eventTypeLabel.trim();
	if (!label) return '';
	return isReservation ? `${label} (${RESERVATION_TYPE_ABBREVIATION})` : label;
};

export const getEventTypeLabelForName = (
	eventTypeLabel: string,
	isReservation = false
): string => {
	const label = eventTypeLabel.trim();
	if (!label) return '';
	if (isReservation || /^reservation$/i.test(label)) {
		return RESERVATION_TYPE_ABBREVIATION;
	}
	return label;
};

/**
 * Auto-generated event name: "Customer Name - Event Type", capped at 25 characters.
 * Reservation types use "Res." so the name stays readable within the limit.
 */
export const buildAutoEventName = (
	customerName: string,
	eventTypeLabel: string,
	isReservation = false
): string => {
	const customer = customerName.trim();
	const typeLabel = getEventTypeLabelForName(eventTypeLabel, isReservation);
	if (!customer || !typeLabel) return '';
	return `${customer} - ${typeLabel}`.slice(0, EVENT_NAME_MAX_LENGTH);
};
